import styled from 'styled-components'

const defaultColor = 'rgb(25, 25, 25)'
const hoverColor = 'rgb(0, 0, 0)'
// const hoverColor = 'rgb(250, 250, 250)'

export const Nav = styled.nav`
  position: absolute;
  top: 10vh;
  left: 0;
  width: 100%;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  letter-spacing: 1em;
  justify-content: center;
  user-select: none;
  > a {
    display: inline-block;
    margin-right: 5px;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 4em;
    font-family: 'Arial Black', sans-serif;
    font-weight: 800;
    line-height: 0.75em;
    letter-spacing: -0.2em;
    color: ${defaultColor};
    &:hover {
      color: ${hoverColor};
    }
  }
`
